import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createBlock as _createBlock, createCommentVNode as _createCommentVNode, unref as _unref, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7c1697d2"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "link-dialog" }
const _hoisted_2 = { class: "tabs" }
const _hoisted_3 = ["onClick"]
const _hoisted_4 = {
  key: 2,
  class: "preview"
}
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "预览：", -1))
const _hoisted_6 = { class: "btns" }
const _hoisted_7 = /*#__PURE__*/_createTextVNode("取消")
const _hoisted_8 = /*#__PURE__*/_createTextVNode("确认")

import { computed, onMounted, ref } from 'vue'
import { storeToRefs } from 'pinia'
import { useMainStore, useSlidesStore } from '@/store'
import { PPTElementLink } from '@/types/slides'
import useLink from '@/hooks/useLink'

import ThumbnailSlide from '@/views/components/ThumbnailSlide/index.vue'

type TypeKey = 'web' | 'slide'
interface TabItem {
  key: TypeKey
  label: string
}


export default /*#__PURE__*/_defineComponent({
  __name: 'LinkDialog',
  emits: ["close"],
  setup(__props, { emit }: { emit: ({
  (event: 'close'): void
}), expose: any, slots: any, attrs: any }) {



const { handleElement } = storeToRefs(useMainStore())
const { slides, currentSlide } = storeToRefs(useSlidesStore())

const type = ref<TypeKey>('web')
const address = ref('')
const slideId = ref('')

slideId.value = slides.value.find(item => item.id !== currentSlide.value.id)?.id || ''

const selectedSlide = computed(() => {
  if (!slideId.value) return null

  return slides.value.find(item => item.id === slideId.value) || null
})

const tabs: TabItem[] = [
  { key: 'web', label: '网页链接' },
  { key: 'slide', label: '幻灯片页面' },
]

const { setLink } = useLink()

onMounted(() => {
  if (handleElement.value?.link) {
    if (handleElement.value.link.type === 'web') address.value = handleElement.value.link.target
    else if (handleElement.value.link.type === 'slide') slideId.value = handleElement.value.link.target

    type.value = handleElement.value.link.type
  }
})

const save = () => {
  const link: PPTElementLink = {
    type: type.value,
    target: type.value === 'web' ? address.value : slideId.value,
  }
  if (handleElement.value) {
    const success = setLink(handleElement.value, link)
    if (success) emit('close')
    else address.value = ''
  }
}

return (_ctx: any,_cache: any) => {
  const _component_Input = _resolveComponent("Input")!
  const _component_SelectOption = _resolveComponent("SelectOption")!
  const _component_Select = _resolveComponent("Select")!
  const _component_Button = _resolveComponent("Button")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (_openBlock(), _createElementBlock(_Fragment, null, _renderList(tabs, (tab) => {
        return _createElementVNode("div", {
          class: _normalizeClass(["tab", { 'active': type.value === tab.key }]),
          key: tab.key,
          onClick: ($event: any) => (type.value = tab.key)
        }, _toDisplayString(tab.label), 11, _hoisted_3)
      }), 64))
    ]),
    (type.value === 'web')
      ? (_openBlock(), _createBlock(_component_Input, {
          key: 0,
          class: "input",
          value: address.value,
          "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((address).value = $event)),
          placeholder: "请输入网页链接地址"
        }, null, 8, ["value"]))
      : _createCommentVNode("", true),
    (type.value === 'slide')
      ? (_openBlock(), _createBlock(_component_Select, {
          key: 1,
          class: "input",
          value: slideId.value,
          "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((slideId).value = $event))
        }, {
          default: _withCtx(() => [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(slides), (slide, index) => {
              return (_openBlock(), _createBlock(_component_SelectOption, {
                key: slide.id,
                value: slide.id,
                disabled: _unref(currentSlide).id === slide.id
              }, {
                default: _withCtx(() => [
                  _createTextVNode("幻灯片 " + _toDisplayString(index + 1), 1)
                ]),
                _: 2
              }, 1032, ["value", "disabled"]))
            }), 128))
          ]),
          _: 1
        }, 8, ["value"]))
      : _createCommentVNode("", true),
    (type.value === 'slide' && _unref(selectedSlide))
      ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
          _hoisted_5,
          _createVNode(ThumbnailSlide, {
            class: "thumbnail",
            slide: _unref(selectedSlide),
            size: 490
          }, null, 8, ["slide"])
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_6, [
      _createVNode(_component_Button, {
        onClick: _cache[2] || (_cache[2] = ($event: any) => (emit('close'))),
        style: {"margin-right":"10px"}
      }, {
        default: _withCtx(() => [
          _hoisted_7
        ]),
        _: 1
      }),
      _createVNode(_component_Button, {
        type: "primary",
        onClick: _cache[3] || (_cache[3] = ($event: any) => (save()))
      }, {
        default: _withCtx(() => [
          _hoisted_8
        ]),
        _: 1
      })
    ])
  ]))
}
}

})